import React from "react"
import {Route, Routes} from "react-router-dom";
import {IncidentFeedListPage} from "@/pages/incident-feeds/incident-feed-list";
import {NewIncidentFeed} from "@/pages/incident-feeds/new-incident-feed";
import {EditIncidentFeed} from "@/pages/incident-feeds/edit-incident-feed";
import {BodyWrapper} from "@/components/body-wrapper";


export function IncidentFeedRoutes() {
    return (
        <BodyWrapper>
            <Routes>
                <Route
                    path="/"
                    element={
                        <IncidentFeedListPage/>
                    }
                />

                <Route
                    path="/create"
                    element={
                        <NewIncidentFeed/>
                    }
                />

                <Route
                    path="/edit/:id"
                    element={
                        <EditIncidentFeed/>
                    }
                />

            </Routes>
        </BodyWrapper>
    )
}
